/* eslint-disable */
import { createStyles } from "@material-ui/styles";
import { Theme, makeStyles } from "@material-ui/core";

export const pickerStyles = (theme: Theme) =>
  createStyles({
    time: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: theme.spacing(0.5),
      color: "rgba(39, 58, 57, 0.8)",
      fontSize: 32,
      lineHeight: "32px",
    },
    timePartition: {
      width: theme.spacing(7),
      borderRadius: theme.spacing(1),
      display: "flex",
      justifyContent: "center",
      fontSize: 32,
      cursor: "pointer",

      "&:hover": {
        background: "rgba(101, 172, 30, 0.2)",
      },
    },
    timePartitionActive: {
      color: "#65AC1E",
    },
  });
export const usePickerStyles = makeStyles(pickerStyles);

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      marginLeft: theme.spacing(1),
      width: theme.spacing(20),
      cursor: "pointer",
    },
    icon: {
      width: theme.spacing(3),
      height: theme.spacing(2.25),
      padding: theme.spacing(0.75, 0.5),
      boxSizing: "content-box",
      "&.focus": {
        "& path": {
          fill: theme.palette.primary.main,
        },
      },
    },
  });
export const useStyles = makeStyles(styles);

export const stylesInput = (theme: Theme) =>
  createStyles({
    root: {
      userSelect: "none",
      minHeight: theme.spacing(4),
      cursor: "pointer",
      background: "rgba(43, 57, 64, 0.07)",
      borderColor: "rgba(43, 57, 64, 0.07)",
      borderRadius: "3px",
      borderStyle: "solid",
      borderWidth: "1px",
      "&:before": {
        display: "none",
      },
      "&:after": {
        display: "none",
      },
      "&.focus": {
        borderColor: theme.palette.primary.main,
      },
    },
    formControl: {},
    focused: {},
    disabled: {},
    underline: {},
    error: {},
    multiline: {},
    fullWidth: {},
    input: {
      cursor: "pointer",
      padding: theme.spacing(1),
      color: "transparent",
      textShadow: "0 0 0 #2B3940",
      fontSize: "14px",
      lineHeight: "17px",
      userSelect: "none",
      "-webkit-touch-callout": "none",
      "-webkit-user-select": "none",
      "-khtml-user-select": "none",
      "-moz-user-select": "none",
      "-ms-user-select": "none",
    },
    inputMarginDense: {},
    inputMultiline: {},
    inputTypeSearch: {},
  });

export const useStylesInput = makeStyles(stylesInput);

export const stylesLabel = (theme: Theme) =>
  createStyles({
    root: {
      fontSize: "14px",
      lineHeight: "16px",
      color: "rgba(43, 57, 64, 0.5)",
      "&.focus": {
        color: theme.palette.primary.main + " !important",
      },
    },
    focused: {
      color: "rgba(43, 57, 64, 0.5) !important",
    },
    disabled: {},
    error: {},
    required: {},
    asterisk: {},
    formControl: {},
    marginDense: {},
    shrink: {
      color: "rgba(43, 57, 64, 0.5)",
    },
    animated: {},
    filled: {},
    outlined: {},
  });

export const useStylesLabel = makeStyles(stylesLabel);

export const stylesPopover = (theme: Theme) =>
  createStyles({
    root: {},
    paper: {
      marginTop: theme.spacing(0.5),
      padding: theme.spacing(2),
      width: 300,
      maxHeight: 364,
    },
  });

export const useStylesPopover = makeStyles(stylesPopover);

export const stylesSearch = (theme: Theme) =>
  createStyles({
    adornedEnd: {
      width: theme.spacing(2),
      height: theme.spacing(2),
      boxSizing: "content-box",
    },
    root: {
      width: "100%",
      marginBottom: theme.spacing(2),
      marginRight: theme.spacing(-1),
      height: theme.spacing(4),
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      background: "rgba(43, 57, 64, 0.07)",
      borderColor: "rgba(43, 57, 64, 0.07)",
      borderRadius: "3px",
      borderStyle: "solid",
      borderWidth: "1px",
      "&:before": {
        display: "none",
      },
      "&:after": {
        display: "none",
      },
      "&.focus": {
        borderColor: theme.palette.primary.main,
      },
    },
    formControl: {},
    focused: {},
    disabled: {},
    underline: {},
    error: {},
    multiline: {},
    fullWidth: {},
    input: {
      userSelect: "none",
      fontSize: "14px",
      lineHeight: "17px",
    },
    inputMarginDense: {},
    inputMultiline: {},
    inputTypeSearch: {},
  });

export const useStylesSearch = makeStyles(stylesSearch);

export const stylesTreeView = (theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      paddingTop: theme.spacing(2.375),
    },
  });

export const useStylesTreeView = makeStyles(stylesTreeView);

export const stylesTreeItem = (theme: Theme) =>
  createStyles({
    root: {
      marginLeft: theme.spacing(2),
    },
    label: {
      width: "100%",
      "& span": {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingTop: theme.spacing(0.5),
        paddingBottom: theme.spacing(0.5),
        fontSize: "14px",
        lineHeight: "17px",
      },
      "& .active": {
        display: "block",
        width: "100%",
        backgroundColor: theme.palette.primary.main,
        borderRadius: "3px",
        color: theme.palette.common.white,
      },
    },
    content: {},
    iconContainer: {},
    expanded: {},
    group: {},
  });

export const useStylesTreeitem = makeStyles(stylesTreeItem);
